import * as React                 from 'react'

export const Biting: React.FC<{ value:string }> = ( props ) =>
{
  const { value } = props ;

  return <div className="text-mono">
         {
           value.split( '|' ).map( (row, index) => <div key={ index }>{ row }</div> )
         }
         </div>
}